import {
    BOOTSTRAP,
    CLEAR_MESSAGING_TOKEN,
    EMULATE_PLAYER,
    FILTER_CONTEXTS,
    NEW_VERSION_AVAILABLE,
    SAVE_MESSAGING_TOKEN,
    TOGGLE_ACTIVE_CONTEXT,
} from "./actions";
import STATUS from "./util/STATUS";
import { DOCUMENT_REFERENCE_DEREFERENCE } from "./util/withDocumentReference";

export function outOfDate(state = false, action) {
    switch (action.type) {
    case NEW_VERSION_AVAILABLE:
        return true;
    default:
        return state;
    }
}

export function messagingToken(state = null, action) {
    switch (action.type) {
    case BOOTSTRAP:
        return action.messagingToken;
    case "@@reactReduxFirebase/SET_PROFILE":
        if (!state) return null;
        if (!action.profile.tokens) return null;
        if (action.profile.tokens.indexOf(state) < 0) return null;
        return state;
    case CLEAR_MESSAGING_TOKEN:
        return null;
    case SAVE_MESSAGING_TOKEN:
        return action.token;
    default:
        return state;
    }
}

export function emulatePlayer(state = false, action) {
    switch (action.type) {
    case EMULATE_PLAYER:
        return action.emulate;
    default:
        return state;
    }
}

export function activeContext(state = null, action) {
    switch (action.type) {
    case BOOTSTRAP:
        const parts = action.path.split("/");
        if (parts[1] === "c" || parts[1] === "s") {
            return parts[2];
        }
        return state;
    case TOGGLE_ACTIVE_CONTEXT:
        return state === action.id ? null : action.id;
    case "@@reduxFirestore/LISTENER_RESPONSE":
        if (action.meta.collection === "contexts") {
            if (action.payload.ordered.length === 1) {
                return action.payload.ordered[0].id;
            } else if (!action.payload.data || !action.payload.data[state]) {
                return null;
            }
        }
        return state;
    default:
        return state;
    }
}

export function documentReferences(state = {}, action) {
    switch (action.type) {
    case DOCUMENT_REFERENCE_DEREFERENCE:
        return Object.assign({
            [action.path]: action.value
        }, state);
    default:
        return state;
    }
}

export function contextFilter(state = STATUS.PUBLISHED, action) {
    switch (action.type) {
    case BOOTSTRAP:
        return action.isLocalhost ? STATUS.DRAFT : state;
    case FILTER_CONTEXTS:
        return action.status;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers.js